import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
import { Input, type CustomProps } from './Input';

export interface InputCurrencyProps extends CustomProps {
  currency?: 'EUR' | 'CHF';
  customInputRef?: HTMLInputElement;
}
const getCurrencySymbol = (currency: 'EUR' | 'CHF'): string => {
  const symbols: Record<'EUR' | 'CHF', string> = {
    EUR: '€',
    CHF: 'CHF',
  };
  return symbols[currency];
};
export const InputCurrency = forwardRef<HTMLInputElement, InputCurrencyProps>(
  (
    {
      currency = 'EUR',
      containerClassName,
      customInputRef,
      helperText,
      label,
      className,
      ...props
    },
    ref,
  ) => (
    <Input
      ref={ref}
      {...props}
      className={cn('pr-4', className)}
      label={label}
      helperText={helperText}
      containerClassName={cn(containerClassName)}
    >
      <span className={cn('pointer-events-none absolute right-2 top-[30%]')}>
        {getCurrencySymbol(currency)}
      </span>
    </Input>
  ),
);
